import styled from 'styled-components/macro';


const PageContainer = styled.div`
	position: relative;
	width: 100%;
	height: 100%;
`;


export default PageContainer;
